import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { Button } from "../../../atoms/Buttons/Base";
import { User } from "../../../models/User";
import { FriendPopupModel } from "../../../models/FriendPopuModel";
import { FriendPopupType, FriendActionState } from "../../../models/Enums";
import {
  setFriendPopupState,
  setFriendActionState,
} from "../../../store/reducers";
import FriendService from "../../../services/Friend/FriendService";
import { SendInvitePopup } from "../FriendPopup/SendInvitePopup";
import { RemoveFriend } from "../FriendPopup/RemoveFriend";
import { InvitationForLoggedInPopup } from "../FriendPopup/InvitationForLoggedInPopup";

import styles from "./FriendWrapperPopup.css";
import FriendApiService from "../../../services/Friend/FriendApiService";
import { MaxCounterToReceivePopup } from "./MaxCounterToReceivePopup";
import { InvitatioinForGuestPopup } from "./InvitatioinForGuestPopup";

interface RootState {
  friendPopupState: FriendPopupModel;
  friendCount?: FriendPopupModel;
}

type FriendWrapperPopupProps = {
  dispatch?: any;
  user: User;
  friendPopupState: FriendPopupModel;
  friendCount?: FriendPopupModel;
};

class FriendWrapperPopupDumb extends React.Component<FriendWrapperPopupProps> {
  state = {
    show: false,
    errorCode: null,
  };

  onLoadContent = (e: any) => {
    this.setState({ show: true });
    document.body.style.overflow = "hidden";
  };

  onPopupClose = (e: any) => {
    this.props.dispatch(
      setFriendPopupState({ type: null, friendToRemove: null })
    );
    this.setState({ show: false });
    document.body.style.overflow = "auto";
  };

  setPopupTypeFromUrl() {
    const { user } = this.props;

    let guid = FriendService.getInvitationGuidFromUrl(FriendService.friendGuid);

    let guidAccept = FriendService.getInvitationGuidFromUrl(
      FriendService.acceptGuid
    );

    if (guid != null && user) {
      this.props.dispatch(
        setFriendPopupState({
          type: FriendPopupType.GetInviteAuthorizedUser,
          friendToRemove: null,
        })
      );
    }

    if (guid != null && !user) {
      this.props.dispatch(
        setFriendPopupState({
          type: FriendPopupType.GetInviteNotAuthorizedUser,
          friendToRemove: null,
        })
      );
    }

    if (guidAccept != null && user) {
      this.props.dispatch(
        setFriendPopupState({
          type: FriendPopupType.AcceptConfirmation,
          friendToRemove: null,
        })
      );
    }
  }

  renderPopupContent() {
    if (!this.props.friendPopupState) return;

    const { user } = this.props;

    switch (this.props.friendPopupState.type) {
      case FriendPopupType.GetInviteNotAuthorizedUser:
        return (
          <InvitatioinForGuestPopup
            onClose={this.onPopupClose}
            onLoadContent={this.onLoadContent}
          />
        );

      case FriendPopupType.GetInviteAuthorizedUser:
        return (
          <InvitationForLoggedInPopup
            user={user}
            onClose={this.onPopupClose}
            onLoadContent={this.onLoadContent}
          />
        );

      case FriendPopupType.MaxCounterToSend:
      case FriendPopupType.SendInvite:
        return (
          <SendInvitePopup
            user={user}
            onClose={this.onPopupClose}
            onLoadContent={this.onLoadContent}
            friendCount={this.props.friendPopupState.friendCount}
            popupType={this.props.friendPopupState.type}
          />
        );

      case FriendPopupType.RemoveFriend:
        return (
          <RemoveFriend
            user={user}
            onClose={this.onPopupClose}
            onLoadContent={this.onLoadContent}
            friendToRemove={this.props.friendPopupState.friendToRemove}
          />
        );

      case FriendPopupType.MaxCounterError:
        return (
          <MaxCounterToReceivePopup
            error={this.state.errorCode}
            onClose={this.onPopupClose}
            onLoadContent={this.onLoadContent}
            popupType={this.props.friendPopupState.type}
          />
        );

      default:
        return;
    }
  }

  async acceptFriendAfterLogin() {
    const guid = FriendService.getInvitationGuidFromUrl(
      FriendService.acceptGuid
    );
    if (guid) {
      FriendApiService.acceptInvite(guid)
        .then(() => {
          this.props.dispatch(
            setFriendActionState(FriendActionState.AcceptConfirmation)
          );
        })
        .catch((fetchError) => {
          if (fetchError.response && fetchError.response.text) {
            return fetchError.response
              .text()
              .then((body) => {
                const errors = JSON.parse(body) as any;
                fetchError.body = body;

                this.setState({ errorCode: errors[0].errorCode });
                this.props.dispatch(
                  setFriendPopupState({
                    type: FriendPopupType.MaxCounterError,
                    friendToRemove: null,
                  })
                );

                throw fetchError;
              })
              .catch((_) => {
                throw fetchError;
              });
          }

          (window as any).history.pushState(
            "",
            "",
            (window as any).location.pathname
          );

          throw fetchError;
        });
    }
  }

  componentDidMount() {
    this.setPopupTypeFromUrl();
    this.acceptFriendAfterLogin();
  }

  render() {
    if (
      this.props.friendPopupState &&
      this.props.friendPopupState.type === FriendPopupType.AcceptConfirmation
    ) {
      return null;
    }
    if (
      this.props.friendPopupState &&
      this.props.friendPopupState.type === FriendPopupType.MaxCounterError &&
      this.state.errorCode &&
      backEndErrorsCodeToIgnorePopup.includes(this.state.errorCode)
    ) {
      return null;
    }

    return (
      <React.Fragment>
        {this.props.friendPopupState && this.props.friendPopupState.type && (
          <Overlay hidden={!this.state.show}>
            <ContainerButton data-element-description="cover message">
              <CloseButton
                aria-label="cover popup close button"
                onClick={this.onPopupClose}
              >
                <img src="/icons/ic_close_menu.png" alt="" width={30} />
              </CloseButton>
              <Container data-element-description="cover message">
                {this.renderPopupContent()}
              </Container>
            </ContainerButton>
          </Overlay>
        )}
      </React.Fragment>
    );
  }
}

export const FriendWrapperPopup = connect((state: RootState) => ({
  friendPopupState: state.friendPopupState,
}))(FriendWrapperPopupDumb);

const Container = ({ hidden, ...props }: any) => (
  <div
    className={classNames(styles.container, { [styles.hidden]: hidden })}
    {...props}
  />
);
const ContainerButton = (props: any) => (
  <div className={styles.containerButton} {...props} />
);
const Overlay = (props: any) => <div className={styles.overlay} {...props} />;
const CloseButton = (props: any) => (
  <Button className={styles.closeButton} {...props} />
);
const backEndErrorsCodeToIgnorePopup = [205, 501, 502] as const;
